import { blobClient, client } from '@api/client';
import { URL } from '@api/urls';

import { DefaultVendorOptions } from '@interfaces/alarms/threshold';
import { IItemsResponse } from '@interfaces/common/response';
import {
	ICreateKpiAlertDTO,
	IEditAlertDTO,
	IGetKpiAlertsHistoryParamsDTO,
	IGetKpiAlertsParamsDTO,
	IKpiAlertDTO,
	IKpiAlertExportDTO,
	IKpiAlertHistoryExportDTO,
	IKpiAlertHistoryOutDTO,
	IKpiAlertSeverityOutDTO,
} from '@interfaces/kpi/dto/kpiAlertsDTO';
import { IRolesResponse, IUserListResponse } from '@interfaces/user/user';

import { TExportFileTypes } from '@enums/common';

export const getKPIAlerts = (
	params: IGetKpiAlertsParamsDTO,
): Promise<IItemsResponse<IKpiAlertDTO>> => {
	return client.get(URL.getKPIAlerts, { params });
};

export const getKPIAlertsForRan = (params: IGetKpiAlertsParamsDTO): Promise<IItemsResponse<IKpiAlertDTO>> => {
	return client.get(URL.getKpiAlertsForRan, { params });
};

export const createKPIAlert = (alert: ICreateKpiAlertDTO): Promise<IKpiAlertDTO> => {
	return client.post(URL.createKpiAlert, alert);
};

export const createKPIAlertForOran = (alert: ICreateKpiAlertDTO): Promise<IKpiAlertDTO> => {
	return client.post(URL.getKpiAlertsForRan, alert);
};

export const getKpiAlertById = (id: string): Promise<IKpiAlertDTO> => {
	return client.get(`${URL.getKPIAlerts}/${id}`);
};

export const getKpiAlertForRanById = (id: string): Promise<IKpiAlertDTO> => {
	return client.get(`${URL.getKpiAlertsForRan}/${id}`);
};

export const editKpiAlert = (alert: IEditAlertDTO): Promise<IKpiAlertDTO> => {
	const { id, ...params } = alert;

	return client.put(`${URL.getKPIAlerts}/${id}`, params);
};

export const editKpiAlertForRan = (alert: IEditAlertDTO): Promise<IKpiAlertDTO> => {
	const { id, ...params } = alert;

	return client.put(`${URL.getKpiAlertsForRan}/${id}`, params);
};

export const getUsersForKpiAlerts = (): Promise<Array<IUserListResponse>> => {
	return client.get(URL.kpiAlertsUsers);
};

export const getRolesForKpiAlerts = (): Promise<Array<IRolesResponse>> => {
	return client.get(URL.kpiAlertsRoles);
};

export const deleteKpiAlerts = (ids: string[]): Promise<void> => {
	return client.post(`${URL.getKPIAlerts}/delete-many`, { ids });
};

export const getKpiAlertsHistory = (
	params: IGetKpiAlertsHistoryParamsDTO,
): Promise<IItemsResponse<IKpiAlertHistoryOutDTO>> => {
	return client.get(`${URL.getKPIAlerts}/history`, { params });
};

export const getKpiAlertsHistoryForRan = (
	params: IGetKpiAlertsHistoryParamsDTO,
): Promise<IItemsResponse<IKpiAlertHistoryOutDTO>> => {
	return client.get(`${URL.getKpiAlertsForRan}/history`, { params });
};

export const getSeverities = (): Promise<Array<IKpiAlertSeverityOutDTO>> => {
	return client.get(`${URL.getKPIAlerts}/static/severities`);
};

export const getKpiAlertsHistoryExport = (
	fileType: TExportFileTypes,
	params: IKpiAlertHistoryExportDTO,
): Promise<any> => {
	return blobClient.post(`${URL.getKPIAlerts}/history/export`, { ...params, fileType });
};

export const getKpiAlertsHistoryExportForRan = (
	fileType: TExportFileTypes,
	params: IKpiAlertHistoryExportDTO,
): Promise<any> => {
	return blobClient.post(`${URL.getKpiAlertsForRan}/history/export`, { ...params, fileType });
};

export const getKpiAlertsExport = (fileType: string, params: IKpiAlertExportDTO): Promise<any> => {
	return blobClient.post(`${URL.getKPIAlerts}/export`, {
		...params,
		fileType,
	});
};

export const getKpiAlertsExportForRan = (fileType: string, params: IKpiAlertExportDTO): Promise<any> => {
	return blobClient.post(`${URL.getKpiAlertsForRan}/export`, {
		...params,
		fileType,
	});
};

export const getKpiAlertVendorsStaticDropdown = (): Promise<DefaultVendorOptions[]> => {
	return client.get(`${URL.getKpiAlertVendorsDropdown}`);
};

export const deleteKpiAlertForRanById = (id: string): Promise<void> => {
	return client.post(`${URL.getKpiAlertsForRan}/${id}`, {});
};

export const deleteManyKpiAlertsForRan = (ids: string[]): Promise<void> => {
	return client.post(`${URL.getKpiAlertsForRan}/delete-many`, { ids });
};
